import type { Identifier } from "ra-core";

import type { Canal, Nota } from "./tipos";

/**
 * Editar notas (Robert, 09/10/2026): el autor corrige el texto y el canal de su nota; los
 * administradores, cualquier nota. El tipo de contacto no cambia (WhatsApp y email son
 * «mensaje» y se intercambian; una llamada sigue siendo llamada). Espejo de
 * public.nevora_tipo_de_canal y del trigger notas_editar (migración 28), que son quienes mandan.
 */

export const tipoDeCanal = (canal: Canal): string =>
  canal === "whatsapp" || canal === "email" ? "mensaje" : canal;

/** Canales a los que se puede cambiar una nota sin cambiar su tipo de contacto. */
export const canalesEditables = (canal: Canal): Canal[] =>
  tipoDeCanal(canal) === "mensaje" ? ["whatsapp", "email"] : [canal];

/**
 * La edición existe cuando la base ya tiene las columnas de la migración 28 (llega el 14/10):
 * hasta entonces las notas no traen `editada_at` y no se ofrece «Editar».
 */
export const edicionDisponible = (nota: object): boolean =>
  "editada_at" in nota;

export const puedeEditarNota = (
  nota: Pick<Nota, "autor"> & Partial<Pick<Nota, "editada_at">>,
  yo: Identifier | null | undefined,
  esAdmin: boolean,
): boolean =>
  edicionDisponible(nota) &&
  (esAdmin || (yo != null && String(nota.autor) === String(yo)));
